import { ILoaiChungChiChungNhanActionTypes } from "../../action-types/category/ILoaiChungChiChungNhanActions";
import { ILoaiChungChiChungNhanReduce } from "../../reducer-model/category/ILoaiChungChiChungNhanReduce";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";


const iniState: ILoaiChungChiChungNhanReduce = {
    status: eReducerStatusBase.is_not_initialization,
    loaiChungChiChungNhans: [],
}

export const loaiChungChiChungNhanReducer = (state: ILoaiChungChiChungNhanReduce = iniState, action: ILoaiChungChiChungNhanActionTypes): ILoaiChungChiChungNhanReduce => {
    switch (action.type) {
        case "LOAI_CHUNG_CHI_CHUNG_NHAN_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "LOAI_CHUNG_CHI_CHUNG_NHAN_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                loaiChungChiChungNhans: action.payload,
            };
        case "LOAI_CHUNG_CHI_CHUNG_NHAN_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "LOAI_CHUNG_CHI_CHUNG_NHAN_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                loaiChungChiChungNhanEditing: action.payload,
            };
        case "LOAI_CHUNG_CHI_CHUNG_NHAN_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "LOAI_CHUNG_CHI_CHUNG_NHAN_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "LOAI_CHUNG_CHI_CHUNG_NHAN_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "LOAI_CHUNG_CHI_CHUNG_NHAN_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "LOAI_CHUNG_CHI_CHUNG_NHAN_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "LOAI_CHUNG_CHI_CHUNG_NHAN_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "LOAI_CHUNG_CHI_CHUNG_NHAN_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}